import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Observable, Subscription } from 'rxjs';
import { DataNamesDTO } from 'src/app/features/locations-map/models/DataNamesDTO';
import { LocationCategoryDTO } from 'src/app/features/locations-map/models/LocationCategoryDTO';
import { LocationDTO } from 'src/app/features/locations-map/models/LocationDTO';
import { RouteSheetTab } from 'src/app/features/locations-map/models/RouteSheetTab';
import { GeneratedLayerService } from 'src/app/features/locations-map/services/Generated-Layer.service';
import { LocationRelatedService } from 'src/app/features/locations-map/services/LocationRelated.service';
import { PanelDetailLocationsService } from 'src/app/features/locations-map/services/Panel-Detail-Locations.service';
import { RouteSheetUtilService } from 'src/app/features/locations-map/services/RouteSheetUtil.service';
import { ConfirmDialogService } from 'src/app/features/shared/features/confirm-dialog/services/Confirm-Dialog.service';
import { MessageDialogService } from 'src/app/features/shared/features/message-dialog/services/message-dialog.service';
import { TutorialService } from 'src/app/features/shared/features/tutorial/services/tutorial.service';
import { CreateEmptyLocationDTO } from 'src/app/features/shared/helpers/DTO/CreateEmptyLocationDTO';
import { EnumLocationCategories } from 'src/app/features/shared/helpers/enums/EnumLocationCategories';
import { EstatusJSON } from 'src/app/features/shared/models/EstatusJSON';
import { NameToSingularPipe } from 'src/app/features/shared/pipes/NameToSingular.pipe';
import { MapService } from 'src/app/features/shared/services/Map.service';
import { NotificationsToastService } from 'src/app/features/shared/services/Notifications-Toast.service';
import { CitronellaActionsService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/CitronellaActions.service';
import { SignalUserService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/Signal-User.service';
import { SessionService } from 'src/app/features/shared/services/Session.service';
import { MapHelperService } from 'src/services/map-helper.service';

@Component({
  selector: 'generic-location-details',
  templateUrl: './generic-location-details.component.html',
  styleUrls: ['./generic-location-details.component.css']
})
export class GenericLocationDetailsComponent {

  images: string[] = [];

  locationDTO: LocationDTO = CreateEmptyLocationDTO();

  Address: string = "";
  locationCategory: LocationCategoryDTO;
  locationCategorySingularName: string;
  Keys: string[] = [];
  KeyNames: DataNamesDTO[] = [];
  Values: string[] = [];
  detallesActivo: string[] = [];
  detallesGPS: string[] = [];
  routeSheets: RouteSheetTab[] = [];
  isVisibleDetails: boolean;
  isVisibleBloking: boolean;
  emptyDates: boolean;
  isAdmin: boolean;
  writeOdometer: boolean;
  fullScreen: boolean = false;
  blokingIcon: string;
  Coords: string;
  hasRelatedData: boolean = false;
  selectedTabIndex: number;

  private activeIdentifier: string = null;
  private $GeneralData: Observable<any> = new Observable<any>();
  private $Address: Observable<string> = new Observable<string>();
  private $Keys: Observable<string[]> = new Observable<string[]>();
  private $KeyNames: Observable<DataNamesDTO[]> = new Observable<DataNamesDTO[]>();
  private $Coords: Observable<string> = new Observable<string>();
  private $Values: Observable<string[]> = new Observable<string[]>();
  private $AllowedBloking: Observable<boolean> = new Observable<boolean>();
  private $BlokingIcon: Observable<boolean> = new Observable<boolean>();
  private $Images: Observable<string[]> = new Observable<string[]>();
  public isLoading: boolean = false;
  public $isLoading: Observable<boolean> = new Observable<boolean>();
  $isVisibleDetails: Observable<boolean> = new Observable<boolean>();

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  roles: string;
  isMapix: boolean = false;
  suscription_updateLocationOdometer: Subscription;
  suscription_confirmDialogService: any;
  suscription_createBlokingRequest: Subscription;
  suscription_getDataNames: Subscription;
  suscription_getLocationRelatedList: Subscription;
  suscription_getGeneralData: Subscription;
  suscription_coords: Subscription;
  suscription_keys: Subscription;
  suscription_keyNames: Subscription;
  suscription_values: Subscription;
  suscription_getOdometer: Subscription;
  suscription_address: Subscription;
  suscription_getLoading: Subscription;
  suscription_isVisibleDetails: Subscription;
  suscription_getImages: Subscription;

  constructor(
    private sessionService: SessionService,
    private confirmDialogService: ConfirmDialogService,
    private mapService: MapService,
    private signalUserService: SignalUserService,
    private messageDialogService: MessageDialogService,
    private panelDetalilService: PanelDetailLocationsService,
    private citronellaActionsService: CitronellaActionsService,
    private snackBar: MatSnackBar,
    private locationRelatedService: LocationRelatedService,
    private generatedLayerService: GeneratedLayerService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private mapHelperService: MapHelperService,
    private tutorialService: TutorialService,
    private notificationsToastService: NotificationsToastService,
    private nameToSingularPipe : NameToSingularPipe,
    private routeSheetUtilService: RouteSheetUtilService
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 760px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.$GeneralData = this.panelDetalilService.getGeneralData();
    this.suscription_getGeneralData = this.$GeneralData.subscribe((element : LocationDTO) => {
      //reseta el componente si se carga otro de la misma categoria
      if (this.activeIdentifier != null && element != null && this.activeIdentifier != element.identifier) {
        this.clearComponent();
      }
      this.locationDTO = element;

      if (this.locationDTO != null && this.locationDTO.identifier != null) {
        this.setActiveLayer();
        this.locationCategory = JSON.parse(localStorage.getItem("listaCategorias")).find((item) => item.id == this.locationDTO.idLocationCategory);
        var x = Number(this.locationDTO.cordsX);
        var y = Number(this.locationDTO.cordsY);
        if (typeof y === 'number'  && typeof x === 'number' && !isNaN(y) && !isNaN(x)) {
          this.Coords = y.toFixed(4) + "," + x.toFixed(4);
        }else{
          this.Coords = "No disponible";
        }
        this.getChildrenLocations();
        this.locationCategorySingularName = this.nameToSingularPipe.transform(this.locationCategory.shortName);
        this.generatedLayerService.createLayer(this.locationCategorySingularName, this.locationCategorySingularName +" seleccionado", ["location"+this.locationCategory.name+"ActiveSource"], true);
        this.activeIdentifier = this.locationDTO.identifier;
      }
       
    });
    this.$Coords = this.panelDetalilService.getCoords();
    this.suscription_coords = this.$Coords.subscribe((element) => {
      this.Coords = "";
      this.Coords = element;
    });

    this.$Keys = this.panelDetalilService.getKeys();
    this.suscription_keys = this.$Keys.subscribe((element) => {
      this.Keys = [];
      this.Keys = element;

      //Crea arrays de detalles del activo
      this.detallesActivo = this.Keys.filter((item) => !item.includes("GPS"));
      this.detallesActivo.sort();
      //Crea arrays de detalles del GPS
      this.detallesGPS = this.Keys.filter((item) => item.includes("GPS"));
      this.detallesGPS.sort();
    });

    this.$KeyNames = this.panelDetalilService.getKeyNames();
    this.suscription_keyNames = this.$KeyNames.subscribe((element) => {
      this.KeyNames = [];
      this.KeyNames = element;
    });
    this.$Values = this.panelDetalilService.getValues();
    this.suscription_values = this.$Values.subscribe((element) => {
      this.Values = [];
      this.Values = element;
    });

    this.$Address = this.panelDetalilService.getAddress();
    this.suscription_address = this.$Address.subscribe((element) => {
      this.Address = "";
      this.Address = element;
    });
    this.$isVisibleDetails = this.panelDetalilService.checkVisibilityPopup();
    this.suscription_isVisibleDetails = this.$isVisibleDetails.subscribe((element) => {
      this.isVisibleDetails = element;
      setTimeout(() => {
        if (this.isVisibleDetails != undefined && this.isVisibleDetails == true) {
          this.tutorialService.startTutorial(["panelDetailLocationTutorial"]);
        }
      }, 1000);
    });
    this.$Images = this.panelDetalilService.getImages();
    this.suscription_getImages = this.$Images.subscribe((element) => {
      this.images = element;
    });
    this.suscription_getLoading = this.panelDetalilService.getLoading().subscribe((data: boolean) => {
      this.isLoading = data;
    });

    // this.InitializePanel();
  }

  ngOnInit(): void {
    this.checkingURL();
  }

  ngOnDestroy() {
    this.clearComponent();
    if (this.suscription_getGeneralData)
      this.suscription_getGeneralData.unsubscribe();
    if (this.suscription_coords)
      this.suscription_coords.unsubscribe();
    if (this.suscription_keys)
      this.suscription_keys.unsubscribe();
    if (this.suscription_keyNames)
      this.suscription_keyNames.unsubscribe();
    if (this.suscription_values)
      this.suscription_values.unsubscribe();
    if (this.suscription_getOdometer)
      this.suscription_getOdometer.unsubscribe();
    if (this.suscription_address)
      this.suscription_address.unsubscribe();
    if (this.suscription_getImages)
      this.suscription_getImages.unsubscribe();
    if (this.suscription_getLoading)
      this.suscription_getLoading.unsubscribe();
  }

  clearComponent(){
    if (this.suscription_updateLocationOdometer)
      this.suscription_updateLocationOdometer.unsubscribe();
    if (this.suscription_confirmDialogService)
      this.suscription_confirmDialogService.unsubscribe();
    if (this.suscription_createBlokingRequest)
      this.suscription_createBlokingRequest.unsubscribe();
    if (this.suscription_getLocationRelatedList)
      this.suscription_getLocationRelatedList.unsubscribe();

    if(this.locationCategorySingularName)
      this.generatedLayerService.deleteLayer(this.locationCategorySingularName, this.locationCategorySingularName +" seleccionado");
    if(this.locationCategory != null){
      this.mapService.UpdateLayerGeoJson("location"+this.locationCategory.name+"ActiveSource",this.mapService.Empty_GeoJson);
      this.mapHelperService.MoveLayer("layer-location"+this.locationCategory.name+"Active", "layer-locationsGeneral");
      this.routeSheetUtilService.clearRouteSheetLayers(this.locationCategory.shortName);
    }
    if(this.locationDTO != null && this.locationDTO.identifier != null)
      this.signalUserService.UnsubscribeSignalUserIdentifierService(this.locationDTO.identifier);
  }

  InitializePanel() {
    // OBSERVABLES PARA BOTON DE BLOQUEO/DESBLOQUEO
    this.$AllowedBloking = this.panelDetalilService.getAllowedBloking();
    this.$AllowedBloking.subscribe((element) => {
      this.isVisibleBloking = element;
    });
    this.$BlokingIcon = this.panelDetalilService.getBlokingIcon();
    this.$BlokingIcon.subscribe((element) => {
      if (element) {
        this.blokingIcon = "lock";
      } else {
        this.blokingIcon = "lock_open";
      }
    });
  }

  getChildrenLocations(){
    // this.suscription_getLocationRelatedList = this.locationRelatedService.GetAllByIdentifier(this.locationDTO.identifier, false).subscribe(data => {
    //   if (data.isSuccess) {
    //     if (data.result.listLocationRelated.length > 0)
    //       this.hasRelatedData = true;
    // }
    // });
    // this.suscription_getLocationRelatedList = this.virtualLocationsService.getLocationCategoryChilds(this.locationDTO.identifier).subscribe(data => {
    //   if (data.isSuccess) {
    //     if (data.result != null && data.result.length > 0)
    //       var titles = data.result;
    //     titles.forEach((element) => {
    //       var categoriesList = JSON.parse(localStorage.getItem('listaCategorias'));
    //       this.routeSheets.push({
    //         routeSheetName: element,
    //         routeSheetIdLocationCategory: categoriesList.find((item) => item.name.toLowerCase() == element.toLowerCase()).id,
    //       });
    //     });
    // }
    // });
    // var categoriesList = JSON.parse(localStorage.getItem('listaCategorias')).filter((item) => !item.itWorksAsGPS && item.id != this.locationDTO.idLocationCategory);
    var categoriesList = JSON.parse(localStorage.getItem('listaCategorias')).filter((item) => item.name.includes(EnumLocationCategories.Unit));
    console.log("generic categorias", categoriesList);
    this.routeSheets = [];
      categoriesList.forEach((element) => {
      this.routeSheets.push({
        total: "-",
          routeSheetName: element.shortName,
          routeSheetIdLocationCategory: element.id,
      });
    });
  }

  OpenWarning(message: string) {
    this.snackBar.open(message, "", {
      duration: 3000,
      horizontalPosition: "center",
      verticalPosition: "bottom",
      //panelClass: "alert"
    });
  }

  removerNoNumero(value: string): string {
    return value.replace(/[^\d.]/g, ""); // Remueve todos los caracteres que no sean números
  }

  getUsableName(keyName: string): string {
    const keyNameObject = this.KeyNames.find((item) => item.keyName == keyName);
    return keyNameObject ? keyNameObject.usableName : keyName;
  }

  //Obtiene la visibilidad según el nombre de la key
  getNameVisibility(keyName) {
    const keyNameObject = this.KeyNames.find(
      (item) => item.keyName === keyName
    );
    return keyNameObject ? keyNameObject.isVisible : true;
  }

  OpenBlokingDialog() {
    if (!this.isLoading) {
      const state = this.blokingIcon == "lock" ? "desbloqueo" : "bloqueo";
      const title = `Solicitud de ${state}`;
      const message = `¿Desea realizar una solicitud de '${state}' para el activo '${this.locationDTO.identifier}'?`;

      this.suscription_confirmDialogService = this.confirmDialogService
        .show(title, message)
        .subscribe((result) => {
          if (result) {
            this.panelDetalilService.setLoading(true);
            this.isLoading = true;
            this.suscription_createBlokingRequest = this.citronellaActionsService
              .createBlokingRequest(this.locationDTO.identifier)
              .subscribe((data: EstatusJSON) => {
                this.messageDialogService.show(title, data.message);
                if (data.isSuccess) {
                  this.panelDetalilService.setBlokingIcon(data.result.locked);
                }
                this.panelDetalilService.setLoading(false);
              });
          }
        });
    }
  }

  CancelButton() {
    this.panelDetalilService.setVisibilityPopup(false);
    //Remove Client to SignalHub
    this.signalUserService.UnsubscribeSignalUserIdentifierService(this.locationDTO.identifier);
    //this.mapService.ResetCamera();
    this.mapService.UpdateLayerGeoJson(
      "location"+this.locationCategory.name+"ActiveSource",
      this.mapService.Empty_GeoJson
    );
    this.mapHelperService.MoveLayer("layer-location"+this.locationCategory.name+"Active", "layer-locationsGeneral");
  }

  checkingURL() {
    this.sessionService.CheckURLSource();
    this.isMapix = this.sessionService.isMapix;
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
    this.notificationsToastService.showSuccess("Texto copiado al portapapeles", text);
  }

   

  selectTab(event: MatTabChangeEvent) {
    if (event.index == 0) {
      this.selectedTabIndex = 0;
      // this.mapHelperService.FlyToCamera(this.locationDTO.cordsY, this.locationDTO.cordsX, "15");
    }else if (event.index == 1){
      this.selectedTabIndex = 1;
    }
  }

  loadTotal(total: string, routeSheet: RouteSheetTab) {
    routeSheet.total = total;
  }

  setActiveLayer() {
    var obj = {
              lat: Number(this.locationDTO.cordsY),
              lng: Number(this.locationDTO.cordsX),
              idntf: this.locationDTO.identifier,
              idLocationCategory: this.locationDTO.idLocationCategory,
              locationCategory: this.locationDTO.locationCategory,
            };
    this.mapHelperService.UpdateActiveLocation(obj);
  }
}
